import { render, staticRenderFns } from "./NewExPage.vue?vue&type=template&id=2e8d1f90"
import script from "./NewExPage.js?vue&type=script&lang=js&external"
export * from "./NewExPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports